import { ReactElement, ReactNode } from 'react';
import { Typography, Tooltip as A, styled } from '@mui/material';
import config from '../../config.json';
import { pathOr } from 'rambda';

export const Tooltip = ({
  name,
  tooltipValue,
  children,
  title,
}: {
  name: string;
  tooltipValue: (tooltip: string) => boolean;
  children: ReactElement;
  title?: ReactNode;
}) => (
  <StyledTooltip
    open={tooltipValue(name)}
    title={
      title === void 0 ? (
        pathOr('idk', name)(config)
      ) : (
        <>
          <Typography
            color="inherit"
            dangerouslySetInnerHTML={{
              __html: pathOr('idk', name)(config),
            }}></Typography>
        </>
      )
    }
    arrow
    placement="top"
    disableFocusListener
    disableHoverListener>
    {children}
  </StyledTooltip>
);

const StyledTooltip = styled(A)(({ theme }) => ({}));
